/**
 * Locomotive Scroll (v5) für Parallax-Effekte über data-scroll-Attribute.
 *
 * Bewusst ohne Smooth-Scroll-Hijack (smoothWheel: false): natives Scrollen
 * bleibt erhalten, Overlays, Scroll-Lock, Scroll-Spy und scrollIntoView
 * funktionieren unverändert — die Lib fährt nur die data-scroll-speed-
 * Transforms anhand der nativen Scroll-Position.
 *
 * data-scroll + data-scroll-speed="0.1"  Parallax (+ schneller, − langsamer,
 *                                        1 ≈ eine Viewport-Höhe Versatz)
 * data-scroll-enable-touch-speed         Parallax auch auf Touch-Geräten
 */
import LocomotiveScroll from 'locomotive-scroll'

if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  new LocomotiveScroll({ lenisOptions: { smoothWheel: false } })
}
